import React, { useState } from 'react';
import { Button, Switch, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { UPDATE_PARTNER } from '~pages/dashboard/referral/partner-account/queries';

function AccountStatusEditor({ partnerId, status, onClose }) {
  const { t } = useTranslation();

  const [updatePartner, { loading: updatePartnerLoading }] = useMutation(UPDATE_PARTNER, {
    onError: e => {
      message.error(e.message);
    },
  });
  const [accountEnable, setAccountEnable] = useState(status);

  const handleSubmit = async () => {
    const response = await updatePartner({
      variables: {
        input: { id: partnerId, enabled: accountEnable },
      },
    });

    if (response?.data?.updatePartner) {
      message.success(t('cms.referral.partner.detail.editor.action.partner_status.toast.success'));
      onClose();
    }
  };

  return (
    <>
      <div className="partner-register-city-editor__body" style={{ marginTop: '8px' }}>
        <section className="partner-register-city-editor__section">
          <main className="partner-register-city-editor__main">
            <div className="">
              <h3 className="partner-account-selector-title">
                {/* {t('cms.referral.partner_account.account_owner')} */}
                Enable Partner Portal access
              </h3>

              <Switch
                loading={updatePartnerLoading}
                defaultChecked={accountEnable}
                onChange={e => {
                  setAccountEnable(e);
                }}
              />
            </div>
            <div>
              This field denotes the status for Partner Portal Access. If it is enabled, the partner
              can log in to the partner portal; if disabled, they will not have access to the
              partner portal.
            </div>
          </main>
        </section>
      </div>
      <div className="partner-register-city-editor__footer">
        <Button
          size="large"
          className="partner-register-city-editor__cancel-button"
          onClick={onClose}
        >
          {t('cms.referral.partner.detail.editor.btn.cancel')}
        </Button>
        <Button
          type="primary"
          size="large"
          className="partner-register-city-editor__save-button"
          loading={updatePartnerLoading}
          onClick={handleSubmit}
        >
          {t('cms.referral.partner.detail.editor.btn.save')}
        </Button>
      </div>
    </>
  );
}

export default AccountStatusEditor;
